// Polyfills
import Glide from '@glidejs/glide';
import 'url-search-params-polyfill';
import "lazysizes";

// Scripts
import './scripts/airport-collapse';
import './scripts/intro-collapse';
import './scripts/hotel-collapse';
import './scripts/filter-query';
import './scripts/filter-mobile-collapse';
import './scripts/navbar-collapse';
import './scripts/navbar-dropdown';
import './scripts/scrollspy';
import './scripts/practical-collapse';
import './scripts/trip-page';
import './scripts/faq-collapse';
import './scripts/pdf-collapse';

if (document.getElementById('glide')) {
    const glide = new Glide('#glide', {
        gap: 0,
        keyboard: true,
        animationDuration: 1000,
    });

    glide.on('move.after', (e) => {

        let slideId = "slide-" + (glide.index + 1);
        let currentSlide = document.getElementById(slideId);
        let name = currentSlide.querySelector(".title");
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'promotionImpression',
            'ecommerce': {
                'promoView': {
                    'promotions': [
                        {
                            'id': 'Forside banner',
                            'name': name.innerText,
                            'creative': 'banner1',
                            'position': 'slot1'
                        },
                    ]
                }
            }
        });

    });

    glide.mount();
}
